module.exports = __webpack_public_path__ + "media/images/new_landing/favicon/apple-touch-icon-84a0138b3b7d8765f0677f5c93ca5401.png";